import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OfficeComponent } from './office.component';
import { HomeComponent } from  './home/home.component';
import { OfficeContractComponent } from './office-contract/office-contract.component';
import { ProfileComponent } from './profile/profile.component';
import { AuthGuardService } from '../shared/security/auth-guard.service';
import { InfoPageComponent } from './info-page/info-page.component';
import { ServiceClientComponent } from './service-client/service-client.component';

const officeRoutes: Routes = [
    {
      path: '',
      component: OfficeComponent,
      children: [
        {
          path: '',
          children: [
            { path: 'home', component: HomeComponent,  canActivate: [AuthGuardService] },
            { path: 'contract', component: OfficeContractComponent,  canActivate: [AuthGuardService] },
            { path: 'profile', component: ProfileComponent,  canActivate: [AuthGuardService] },
            { path: 'account_status', loadChildren: 'app/office/account-status/account-status.module#AccountStatusModule'},
            { path: 'authorization', loadChildren: 'app/office/authorization/authorization.module#AuthorizationModule'},
            { path: 'medical_appointment', loadChildren: 'app/office/medical-appointment/medical-appointment.module#MedicalAppointmentModule'},
            { path: 'laboratory_tests', loadChildren: 'app/office/laboratory-tests/laboratory-tests.module#LaboratoryTestsModule' },
            { path: 'certificate', loadChildren: 'app/office/certificate/certificate.module#CertificateModule'},
            { path: 'news', loadChildren: 'app/office/news/news.module#NewsModule' },
            { path: 'info', component: InfoPageComponent,  canActivate: [AuthGuardService]},
            { path: 'service_client', component: ServiceClientComponent},
            { path: '', component: HomeComponent,  canActivate: [AuthGuardService] },
            { path: 'refunds', loadChildren: 'app/office/refunds/refund.module#RefundModule'},
          ]
        }
      ]
    }
  ];
  
  @NgModule({
    imports: [
      RouterModule.forChild(officeRoutes)
    ],
    exports: [
      RouterModule
    ]
  })
  export class OfficeRoutingModule {}


// WEBPACK FOOTER //
// /app/src/app/office/office-routing.module.ts